/* eslint-disable no-undef */
interface AdoptInterface {
  element?: Element
  selector?: string | ((e: Element) => Element | ChildNode)
  className?: string
  children?: {
    [key: string]: AdoptInterface
  }
}

export default function changeLayoutAdopt() {
  const elements = document.querySelectorAll('*')

  if (elements?.length) {
    const adoptContainer: Element = Array.from(elements).find(
      (element) =>
        element?.classList?.length &&
        element?.className?.includes('adopt') &&
        element.id !== 'adopt-controller-button' &&
        element?.tagName !== 'SCRIPT'
    )

    const applyChangeLayoutElement = ({ element = adoptContainer, className = 'adopt', children = {}, selector = null }) => {
      if (typeof selector === 'function') {
        selector(element)?.classList?.add(className)
      } else {
        element?.classList?.add(className)
      }

      if (Object?.entries(children)?.length) {
        for (const subElement of Object.values(children)) {
          applyChangeLayoutElement({
            element: typeof selector === 'function' ? selector(element) : element?.[(subElement as any)?.selector],
            className: (subElement as any)?.className,
            children: (subElement as any)?.children,
            selector: (subElement as any)?.selector,
          })
        }
      }
    }

    const adopt: AdoptInterface = {
      element: adoptContainer,
      selector: '',
      className: 'adopt',
      children: {
        adoptContent: {
          selector: 'firstElementChild',
          className: 'adopt-content',
          children: {
            adoptMainContent: {
              selector: 'firstElementChild',
              className: 'adopt-main-content',
              children: {
                adoptMainBar: {
                  selector: 'lastElementChild',
                  className: 'adopt-main-bar',
                  children: {
                    adoptMainBarDescription: {
                      selector: 'firstElementChild',
                      className: 'adopt-main-bar-description',
                    },
                  },
                },
                adoptMainContentHeader: {
                  selector: 'firstElementChild',
                  className: 'adopt-main-content-header',
                  children: {
                    adoptTitle: {
                      selector: 'firstElementChild',
                      className: 'adopt-title',
                    },
                    adoptLink: {
                      selector: 'lastElementChild.firstElementChild',
                      className: 'adopt-link',
                    },
                  },
                },
                adoptFastLinks: {
                  selector: (e: Element) => (e?.firstChild?.firstChild?.lastChild as any)?.querySelectorAll('*')?.[1],
                  className: 'adopt-fast-links',
                },
                adoptDevelopedBy: {
                  selector: (e: Element) => e?.firstChild?.firstChild?.lastChild?.lastChild,
                  className: 'adopt-developed-by',
                },
              },
            },
            adoptButtons: {
              selector: 'lastElementChild',
              className: 'adopt-buttons',
              children: {
                adoptButtonAsLink: {
                  selector: 'firstElementChild',
                  className: 'adopt-button-as-link',
                },
                adoptButtonReject: {
                  selector: (e: Element) => (e?.firstChild?.lastChild as any)?.querySelectorAll('*')?.[1],
                  className: 'adopt-button-reject',
                },
              },
            },
          },
        },
      },
    }

    applyChangeLayoutElement(adopt)
  }
}
